"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDynamicFieldError = exports.handleDynamicFieldBlur = exports.handleDynamicFieldChange = exports.getFileSSTParameter = exports.doesTemplateContainsFileField = exports.hasFileField = exports.getImageFileType = exports.getFileExtension = exports.getFileFormData = exports.getActionLabel = exports.getParentStringFromArray = exports.getApprovalStatus = void 0;

var _constants = require("../secrets/constants");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var getApprovalStatus = function getApprovalStatus(status) {
  switch (status === null || status === void 0 ? void 0 : status.toLowerCase()) {
    case _constants.MyApprovalsStatus.pending:
      return _constants.translateStrings.approvalPending;

    case _constants.MyApprovalsStatus.rejected:
      return _constants.translateStrings.rejected;

    case _constants.MyApprovalsStatus.timeout:
      return _constants.translateStrings.timeout;

    case _constants.MyApprovalsStatus.approved:
      return _constants.translateStrings.approvedText;

    case _constants.MyApprovalsStatus.cancelled:
      return _constants.translateStrings.requestCancelled;

    default:
      return _constants.translateStrings.noneText;
  }
};

exports.getApprovalStatus = getApprovalStatus;

var getParentStringFromArray = function getParentStringFromArray(parents) {
  if ((parents === null || parents === void 0 ? void 0 : parents.length) === 0) return '/';
  var parentsString = '';

  for (var i in parents) {
    parentsString += "/".concat(parents[i].label);
  }

  return parentsString;
};

exports.getParentStringFromArray = getParentStringFromArray;

var getActionLabel = function getActionLabel(action) {
  if (action) {
    if (action === _constants.MyApprovalsStatus.secretReadActionName) {
      return _constants.translateStrings.viewSecret;
    }

    return action;
  }

  return _constants.translateStrings.noneText;
};

exports.getActionLabel = getActionLabel;

var getFileFormData = function getFileFormData(payloadBody) {
  var formData = new FormData();

  for (var key in payloadBody.value) {
    if (_typeof(payloadBody.value[key]) === 'object' && Object.hasOwnProperty.call(payloadBody.value[key], 'file') && payloadBody.value[key].file === null) {
      payloadBody.value[key] = '';
      break;
    }

    if (_typeof(payloadBody.value[key]) === 'object' && Object.hasOwnProperty.call(payloadBody.value[key], 'file') && typeof payloadBody.value[key].file.name === 'string') {
      formData.append('file', payloadBody.value[key].file);
      payloadBody.value[key] = payloadBody.value[key].randomKey;
      break;
    }
  }

  formData.append('secretData', JSON.stringify(payloadBody));
  return formData;
};

exports.getFileFormData = getFileFormData;

var getFileExtension = function getFileExtension(filename) {
  return filename.substring(filename.lastIndexOf('.') + 1, filename.length).toLowerCase();
};

exports.getFileExtension = getFileExtension;

var getImageFileType = function getImageFileType(filename) {
  // func is used to generate a type string like 'image/png' for a file
  // https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
  var fileExtension = getFileExtension(filename);

  switch (fileExtension) {
    case 'jpg' || 'jpeg' || 'jfif' || 'pjpeg' || 'pjp':
      return 'image/jpeg';

    case 'svg':
      return 'image/svg+xml';

    default:
      // for all other types of  image file extension is the type
      return "image/".concat(fileExtension);
  }
};

exports.getImageFileType = getImageFileType;

var hasFileField = function hasFileField(object) {
  var hasFile = false;

  for (var key in object) {
    var attribute = object[key];

    if (_typeof(attribute) === 'object' && Object.hasOwnProperty.call(attribute, 'file')) {
      hasFile = true;
    }
  }

  return hasFile;
}; // check if SST


exports.hasFileField = hasFileField;

var doesTemplateContainsFileField = function doesTemplateContainsFileField(_ref) {
  var parameters = _ref.parameters;
  var hasFile = false;
  parameters === null || parameters === void 0 ? void 0 : parameters.map(function (element) {
    if (element.type === 'fileUpload') {
      hasFile = true;
    }
  });
  return hasFile;
};

exports.doesTemplateContainsFileField = doesTemplateContainsFileField;

var getFileSSTParameter = function getFileSSTParameter(parameters) {
  var sstFileParameter = null;
  parameters.map(function (element) {
    if (element.type === 'fileUpload') {
      sstFileParameter = element;
    }
  });
  return sstFileParameter;
}; // takes a prefix and adds to a dynamic field 


exports.getFileSSTParameter = getFileSSTParameter;

var handleDynamicFieldChange = function handleDynamicFieldChange(hook, prefix, fieldName, value) {
  hook.handleChange("".concat(prefix, "-").concat(fieldName), value);
};

exports.handleDynamicFieldChange = handleDynamicFieldChange;

var handleDynamicFieldBlur = function handleDynamicFieldBlur(hook, prefix, fieldName) {
  hook.handleBlur("".concat(prefix, "-").concat(fieldName));
};

exports.handleDynamicFieldBlur = handleDynamicFieldBlur;

var getDynamicFieldError = function getDynamicFieldError(hook, prefix, fieldName) {
  var fieldPrefixedName = "".concat(prefix, "-").concat(fieldName);
  return hook.touched[fieldPrefixedName] && hook.errors[fieldPrefixedName] ? hook.errors[fieldPrefixedName] : '';
};

exports.getDynamicFieldError = getDynamicFieldError;